/*
 * Created on Wed April 27 2021
 * Created By Ashish
 * Copyright (c) 2021 Flix
 */
import axios from "axios";
import { BASE_URL, loginUrl, MapKey } from "../../app_config";

let userId: string;
export const getUserUid = () => {
  const user = localStorage.getItem("user");
  if (!user || !userId || userId === "") {
    alert("user not authenticated");
  }
  if (user) {
    userId = JSON.parse(user).userId;
  }
};

/** call this method upon logout, so upon after db read after subsequent login `userUid` will be initialized again */
export const resetUserId = () => {
  localStorage.removeItem("userId");
};

const token = localStorage.getItem("jwtToken");
const requestObj = axios.create({
  baseURL: `${BASE_URL}/`,
  responseType: "json",
  // timeout: 5000,
  headers: Object.assign({
    "content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  }),
});

const requestObjForImageUpload = axios.create({
  baseURL: `${BASE_URL}/api/`,
  responseType: "json",
  headers: {
    "content-Type": "multipart/form-data",
    Authorization: `Bearer ${token}`,
  },
});

export function postApiCall(apiName: string, parameters: any) {
  return requestObj
    .post(`${apiName}`, parameters)
    .then((res: any) => {
      if (apiName === loginUrl && res.data.Status) {
        requestObj.defaults.headers.Authorization =
          "Bearer " + res.data.Data.JwtToken;
        requestObjForImageUpload.defaults.headers.Authorization =
          "Bearer " + res.data.Data.JwtToken;
      }
      return res.data;
    })
    .catch((error) => {
      if (error && error.toString().includes("401")) {
        localStorage.clear();
        window.location.href = "/login";
        return true;
      }
      return error;
    });
}

export function getApiCall(apiName: string, parameters: string) {
  return requestObj
    .get(`${apiName}?${parameters}`)
    .then((res: any) => {
      return res.data;
    })
    .catch((error) => {
      if (error && error.toString().includes("401")) {
        localStorage.clear();
        window.location.href = "/login";
        return true;
      }
      return error;
    });
}

export function imageUploadApi(apiName: string, parameters: any) {
  return requestObjForImageUpload
    .post(`${apiName}`, parameters)
    .then((res: any) => {
      return res.data;
    });
}

export function getAddressDatailFromLocation(currentLocation: any) {
  const requestObjConfig = axios.create({
    baseURL: `https://maps.googleapis.com/maps/api/geocode`,
    responseType: "json",
    headers: { "content-Type": "application/json" },
  });

  return requestObjConfig
    .get(
      `/json?latlng=${currentLocation.lat},${currentLocation.lng}&key=${MapKey}`
    )
    .then((res) => {
      return res.data;
    });
}

// http://192.168.0.58/FlixValetApi/ValetServices/FetchCustomerFromEmailAndMobile
export function FetchCustomerFromEmailAndMobile(apiName: string, parameters: any) {
  return requestObj
  .post(`${apiName}`, parameters)
    .then((res: any) => {
        requestObj.defaults.headers.Authorization = "Bearer " + res.data.Data.JwtToken;
        requestObjForImageUpload.defaults.headers.Authorization = "Bearer " + res.data.Data.JwtToken;
      return res.data;
    })
    .catch((error) => {
      return error;
    });
}
